import * as React from 'react';
import { Props as IReactSelectProps } from 'react-select/lib/Select';

import IMPComponent from '../interfaces/IMPComponent';

import Select from '../Select';

interface IYearSelectProps extends IMPComponent, IReactSelectProps {
  selectedYear?: number;
  yearFrom?: number;
  yearTo?: number;
}

const getYearOptions = (yearFrom: number, yearTo: number = new Date().getFullYear()) => {
  const result: Array<{ label: string; value: string }> = [];

  for (let i = yearTo; i >= yearFrom; i -= 1) {
    result.push({
      label: String(i),
      value: String(i),
    });
  }
  return result;
};
const YearSelect: React.FunctionComponent<IYearSelectProps> = ({
  className,
  style,
  yearFrom,
  yearTo,
  selectedYear,
  ...props
}) => {
  const options = getYearOptions(yearFrom as number, yearTo);

  const defaultYear = selectedYear
    ? {
        label: String(selectedYear),
        value: String(selectedYear),
      }
    : options[0];

  return (
    <div style={style}>
      <Select options={options} value={defaultYear} {...props} />
    </div>
  );
};

YearSelect.defaultProps = {
  yearFrom: 1970,
};

export default React.memo(YearSelect);



// WEBPACK FOOTER //
// ./src/components/YearSelect/index.tsx